import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Mendoza | El Arsenal del Profe',
    text: 'Tengo 12 grupos distintos por semana. Antes llegaba agotada al lunes. Ahora abro el tomo que necesito y listo. No hay vuelta atrás.'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata | Arsenal + Potenciador',
    text: 'El Tomo 1 me salvó el día que llegué y el depósito estaba con llave. Hice una clase entera sin un solo material y los chicos no se dieron cuenta.'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Santa Fe | Escuela Secundaria',
    text: 'El Potenciador me cambió la forma de usar las pelotas y los conos. Mis alumnos de 4to año me preguntan si vamos a hacer el circuito de nuevo.'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén | Instructor Deportivo',
    text: 'No soy profe de escuela pero guío grupos de actividad física. Funciona igual de bien para mí. El Bono de Frases GAP es oro puro.'
  }];
  return <Section className="bg-gray-50" data-id="element-148">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-149">
        {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-150">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col" data-id="element-151">
              <div className="flex items-center gap-3 mb-4" data-id="element-152">
                <div className="w-10 h-10 bg-navy text-white rounded-full flex items-center justify-center font-bold text-sm shrink-0" data-id="element-153">
                  {t.initials}
                </div>
                <div data-id="element-154">
                  <div className="flex text-yellow-400 mb-1" data-id="element-155">
                    {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-current" data-id="element-156" />)}
                  </div>
                  <p className="font-bold text-navy text-sm" data-id="element-157">{t.name}</p>
                  <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-158">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-gray-600 text-sm italic" data-id="element-159">"{t.text}"</p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-navy text-white py-20" data-id="element-160">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-161">
        <ShieldCheck size={80} className="mx-auto text-brandOrange mb-6" data-id="element-162" />
        <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-163">
          🛡️ GARANTÍA 30 DÍAS — SIN PREGUNTAS
        </h2>
        <div className="text-xl text-gray-300 space-y-4 mb-8" data-id="element-164">
          <p data-id="element-165">Abrís los tomos.</p>
          <p data-id="element-166">Los usás en el aula o en tus clases.</p>
          <p className="text-white font-bold text-2xl py-2" data-id="element-167">
            Si en 30 días no es lo que esperabas:
            <br data-id="element-168" />
            devolución del 100%.
          </p>
          <p data-id="element-169">Sin formularios. Sin drama. Sin vueltas.</p>
          <p data-id="element-170">
            Un mail a{' '}
            <a href="mailto:soportecentershop95@gmail.com" className="text-brandOrange hover:underline" data-id="element-171">
              soportecentershop95@gmail.com
            </a>{' '}
            y listo.
          </p>
        </div>
        <p className="text-sm text-gray-400 font-medium" data-id="element-172">
          Tasa de devoluciones: menos del 2%.
        </p>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para primaria y secundaria?',
    a: 'Sí. Los 6 Tomos están pensados para ambos niveles. Cada actividad indica para qué edad y contexto funciona mejor.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. PDF de alta calidad. Acceso inmediato al pago. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Funciona si no soy profe de escuela?',
    a: 'Sí. Cualquier persona que guíe grupos de actividad física (instructores, animadores, recreadores, profesores particulares) puede usar este sistema sin problema.'
  }, {
    q: '¿Necesito materiales deportivos para usarlo?',
    a: 'No. Los 6 Tomos del Arsenal están diseñados para funcionar sin ningún material. El Potenciador (upsell opcional) usa materiales que ya están en cualquier escuela o gimnasio.'
  }, {
    q: '¿Tiene garantía real?',
    a: '30 días. Sin preguntas. Sin formularios. Un mail y te devolvemos el 100%.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-white" data-id="element-173">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-174">
        <h2 className="text-3xl md:text-4xl font-bold text-navy text-center mb-10" data-id="element-175">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-4" data-id="element-176">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-2xl overflow-hidden" data-id="element-177">
              <button className="w-full px-6 py-4 text-left font-bold text-navy flex justify-between items-center hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-178">
                <span data-id="element-179">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="text-brandOrange" data-id="element-180" /> : <ChevronDown className="text-gray-400" data-id="element-181" />}
              </button>
              {openIndex === i && <div className="px-6 pb-4 text-gray-600" data-id="element-182">{faq.a}</div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 horas de búsqueda de juegos por semana',
    costo: '120 horas de tu vida por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupos que se te van de las manos'
  }, {
    sin: 'Sin plan B para lluvia',
    costo: 'Clase perdida + estrés innecesario'
  }, {
    sin: 'Sin consignas listas',
    costo: 'Explicás 3 veces y la mitad no entiende'
  }, {
    sin: 'Siempre los mismos juegos',
    costo: 'Grupos que se aburren y no participan'
  }, {
    sin: 'Domingo buscando en Google',
    costo: 'El mismo ciclo, el próximo año'
  }];
  return <Section className="bg-navy text-white" data-id="element-183">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-184">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-brandOrange" data-id="element-185">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-white/5 rounded-3xl overflow-hidden border border-white/10 mb-10" data-id="element-186">
          <div className="grid grid-cols-2 bg-white/10 p-4 font-bold text-sm md:text-base" data-id="element-187">
            <div className="text-gray-300" data-id="element-188">Sin El Arsenal</div>
            <div className="text-white pl-4 border-l border-white/10" data-id="element-189">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-white/5" data-id="element-190">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 gap-4 text-sm md:text-base items-center hover:bg-white/5 transition-colors" data-id="element-191">
                <div className="text-gray-400 pr-4" data-id="element-192">{row.sin}</div>
                <div className="text-red-400 font-medium pl-4 border-l border-white/10 flex items-center gap-2" data-id="element-193">
                  <span className="hidden md:inline" data-id="element-194">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <p className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-195">
          El próximo domingo puede ser diferente.
        </p>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <Section className="bg-navy border-t border-white/10 pt-16 pb-24" data-id="element-196">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-197">
        <div className="mb-12" data-id="element-198">
          <h3 className="text-xl font-bold text-gray-300 mb-4" data-id="element-199">
            ⏰ EL PRECIO CIERRA EN:
          </h3>
          <div className="inline-flex items-center gap-2 bg-white/10 px-6 py-3 rounded-2xl text-3xl font-black text-white" data-id="element-200">
            <span data-id="element-201">{hours.toString().padStart(2, '0')}</span>
            <span className="text-brandOrange" data-id="element-202">:</span>
            <span data-id="element-203">{minutes.toString().padStart(2, '0')}</span>
            <span className="text-brandOrange" data-id="element-204">:</span>
            <span data-id="element-205">{seconds.toString().padStart(2, '0')}</span>
          </div>
        </div>

        <div className="space-y-6 mb-12" data-id="element-206">
          {/* Option 1 */}
          <div className="bg-white/5 border border-white/10 rounded-3xl p-6 md:p-8 hover:bg-white/10 transition-colors" data-id="element-207">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-208">
              <div className="text-left" data-id="element-209">
                <h4 className="text-2xl font-bold text-white mb-1" data-id="element-210">
                  📘 EL ARSENAL DEL PROFE
                </h4>
                <p className="text-gray-400 text-sm" data-id="element-211">
                  6 Tomos + 6 Bonos · Primaria + Secundaria
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-212">
                <p className="text-gray-500 line-through text-sm" data-id="element-213">$49.990</p>
                <p className="text-3xl font-black text-white" data-id="element-214">
                  $19.990{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-215">ARS</span>
                </p>
              </div>
            </div>
            <div className="mt-6" data-id="element-216">
              <CTAButton href="https://centershop.store/cart/47907894886645:1" fullWidth variant="secondary" className="!bg-white/10 !text-white !border-white/20 hover:!bg-white/20" data-id="element-217">
                QUIERO MI ARSENAL AHORA
              </CTAButton>
            </div>
          </div>

          {/* Option 2 */}
          <div className="bg-gradient-to-br from-brandOrange/20 to-transparent border-2 border-brandOrange rounded-3xl p-6 md:p-8 relative" data-id="element-218">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brandOrange text-white px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-219">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-220">
              <div className="text-left" data-id="element-221">
                <h4 className="text-2xl font-bold text-white mb-1" data-id="element-222">
                  🏆 ARSENAL + POTENCIADOR
                </h4>
                <p className="text-brandOrange text-sm font-medium" data-id="element-223">
                  6 Tomos + 6 Bonos + 3 Volúmenes Potenciador
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-224">
                <p className="text-gray-500 line-through text-sm" data-id="element-225">$67.990</p>
                <p className="text-3xl font-black text-white" data-id="element-226">
                  $27.990{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-227">ARS</span>
                </p>
              </div>
            </div>
            <div className="mt-6" data-id="element-228">
              <CTAButton href="https://centershop.store/cart/47907900162293:1" fullWidth data-id="element-229">
                QUIERO EL ARSENAL + POTENCIADOR
              </CTAButton>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-230">
          <span className="flex items-center gap-2" data-id="element-231">
            <Lock size={18} data-id="element-232" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-233">
            <Clock size={18} data-id="element-234" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-235">
            <ShieldCheck size={18} data-id="element-236" /> Garantía 30 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-237">
            <CreditCard size={18} data-id="element-238" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-[#0f1d2e] text-gray-400 py-12 px-4 border-t border-white/5" data-id="element-239">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-240">
        <div data-id="element-241">
          <h2 className="text-2xl font-black text-white mb-1" data-id="element-242">
            ⚽ EL ARSENAL DEL PROFE™
          </h2>
          <p className="text-sm" data-id="element-243">by CenterShop Digital</p>
        </div>

        <p className="text-gray-300 max-w-md mx-auto" data-id="element-244">
          El sistema de clases listas N°1 para profes de Educación Física en
          Argentina. Porque dar una buena clase no debería costarte todos los
          domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm pt-4" data-id="element-245">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-white transition-colors" data-id="element-246">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-247">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-white/10 text-xs space-y-2" data-id="element-248">
          <p data-id="element-249">© 2024 CenterShop Digital. Todos los derechos reservados.</p>
          <p className="space-x-4" data-id="element-250">
            <a href="#" className="hover:text-white transition-colors" data-id="element-251">
              Términos y condiciones
            </a>
            <span data-id="element-252">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-253">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};